import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ModuleModal component styles
 * @returns {Function}
 */

export const useStyles = makeStyles(() =>
  createStyles({
    DVModalWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      position: 'absolute',
      height: 'calc(150vh + 24.2rem)',
      top: 0,
      zIndex: 1,
      padding: '25rem 0 0',

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        margin: '0 auto',
        position: 'static',
        // width: 'calc(100% - 49.2rem)',
        width: '63.2rem',
      },
    },

    moduleContent: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      padding: '2rem 1.6rem',
      position: 'relative',
      width: '100%',
    },

    imageWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(62% - 26.5px)',
      justifyContent: 'center',
      // margin: '0 5px',
      // overflow: 'hidden',
      // paddingTop: '2rem',
      position: 'relative',
    },

    image: {
      maxHeight: '100%',
      maxWidth: '100%',
    },

    defaultImageWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(38% - 26.5px)',
      justifyContent: 'center',
      // margin: '0 5px',
      // overflow: 'hidden',
      position: 'relative',
      width: 'calc(100% - 10px)',
    },

    DVImageLabel: {
      // fontSize: '20px',
      // textTransform: 'uppercase',
      // left: '50%',
      // position: 'absolute',
      // transform: 'translateX(-50%)',
      // top: '0rem',
    },

    defaultImage: {
      maxHeight: '100%',
      maxWidth: '100%',
    },

    actions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 0 1.6rem 0', // '10px',
    },

    actionBtn: {},

    segmentSelect: {
      width: '240px',
    },
  }),
);
